export const Tags = {
  CUSTOM_ERROR: "custom-error",
  SALES_MEETING: "sales-meeting",
};
